export default __webpack_public_path__ + "static/media/No-Image.3d85f38b.svg";